// export DsfVirtualList from "./virtualList.vue";

export const DsfVirtualList=dsf.defineLazyComponent('DsfVirtualList',()=>require("./virtualList.vue"))

